module.exports = __webpack_public_path__ + "static/img-planificacion-plain-2cb60b3334681fcdf05037a759818517.png";